import types from 'actions/types'
import * as priceLists from 'actions/priceLists'

// Define if the state should be saved now or debounced
export const PersistenceType = {
  IMMEDIATE: 'IMMEDIATE',
  DEBOUNCE: 'DEBOUNCE',
}

export const Whitelist = {
  [types.ONBOARDING_DISMISS_INFO]: PersistenceType.IMMEDIATE,
  [types.ONBOARDING_SKILL_FINISH]: PersistenceType.IMMEDIATE,
  [types.ONBOARDING_SKILL_HINT_DISMISS]: PersistenceType.IMMEDIATE,
  [types.SEARCH_UPDATE_FILTERS]: PersistenceType.DEBOUNCE,
  [types.DIARY_UPDATE_COMPLETED_ACTIVITIES]: PersistenceType.DEBOUNCE,
  [types.DIARY_UPDATE_REJECTED_ACTIVITIES]: PersistenceType.DEBOUNCE,
  [types.DIARY_UPDATE_CALENDAR_ACTIVITY_OPTIONS_ORDER]: PersistenceType.IMMEDIATE,
  [types.DIARY_UPDATE_CALENDAR_ACTIVITY_OPTIONS]: PersistenceType.IMMEDIATE,
  [types.DIARY_UPDATE_AGENDA_ACTIVITY_OPTIONS_Order]: PersistenceType.IMMEDIATE,
  [types.DIARY_UPDATE_AGENDA_ACTIVITY_OPTIONS]: PersistenceType.IMMEDIATE,
  [types.DIARY_UPDATE_ACTIVITY_TYPE]: PersistenceType.DEBOUNCE,
  [types.DIARY_UPDATE_USERS]: PersistenceType.DEBOUNCE,
  [types.DIARY_UPDATE_COMPANIES]: PersistenceType.DEBOUNCE,
  [types.DIARY_UPDATE_CONTACTS]: PersistenceType.DEBOUNCE,
  [types.DIARY_UPDATE_REFERENCES]: PersistenceType.DEBOUNCE,
  [types.CONTACTS_UPDATE_FILTERS]: PersistenceType.DEBOUNCE,
  [types.CONTACTS_SET_FIELD_SELECT_MODE]: PersistenceType.DEBOUNCE,
  [types.CONTACTS_RECENTS_ADD]: PersistenceType.DEBOUNCE,
  [types.CONTACTS_RECENTS_REMOVE]: PersistenceType.DEBOUNCE,
  [types.CONTACTS_RECENTS_CLEAR]: PersistenceType.DEBOUNCE,
  [types.CONTACTS_RECENTS_SET]: PersistenceType.DEBOUNCE,
  [types.CONTACTS_SET_CONTACT_FIELDS]: PersistenceType.DEBOUNCE,
  [types.CONTACTS_SET_COMPANY_FIELDS]: PersistenceType.DEBOUNCE,
  [types.CONTACTS_SET_CONTACT_LIST]: PersistenceType.DEBOUNCE,
  [types.CONTACTS_SET_INDIVIDUAL_FIELDS]: PersistenceType.DEBOUNCE,
  [types.CONTACTS_TOGGLE_CONTACT_FIELD]: PersistenceType.DEBOUNCE,
  [types.CONTACTS_TOGGLE_COMPANY_FIELD]: PersistenceType.DEBOUNCE,
  [types.CONTACTS_TOGGLE_INDIVIDUAL_FIELD]: PersistenceType.DEBOUNCE,
  [types.CONTACTS_ACTIVITIES_UPDATE_FILTERS]: PersistenceType.DEBOUNCE,
  [types.CONTACTS_OPPORTUNITIES_UPDATE_FILTERS]: PersistenceType.DEBOUNCE,
  [types.CONTACTS_QUOTES_UPDATE_FILTERS]: PersistenceType.DEBOUNCE,
  [types.CONTACTS_INVOICES_UPDATE_FILTERS]: PersistenceType.DEBOUNCE,
  [types.CONTACTS_COMPANY_CONTACTS_TOGGLE_DORMANTS]: PersistenceType.DEBOUNCE,
  [types.CONTACT_LISTS_TOGGLE_HIDDEN_LISTS]: PersistenceType.DEBOUNCE,
  [types.CONTACT_LISTS_SELECT_CATEGORY]: PersistenceType.DEBOUNCE,
  [types.CONTACT_LISTS_ADD_CATEGORY_SUCCESS]: PersistenceType.DEBOUNCE,
  [types.CONTACT_LISTS_EXPAND_CATEGORY]: PersistenceType.DEBOUNCE,
  [types.CONTACT_LISTS_COLLAPSE_CATEGORY]: PersistenceType.DEBOUNCE,
  [types.CONTACTGRID_UPDATE_FILTERS]: PersistenceType.DEBOUNCE,
  [types.DELIVERIES_READY_FOR_DELIVERY_UPDATE_FILTERS]: PersistenceType.DEBOUNCE,
  [types.DELIVERIES_DELIVERY_NOTES_UPDATE_FILTERS]: PersistenceType.DEBOUNCE,
  [types.EMAILING_TOGGLE_SEND_COPY_FROM]: PersistenceType.DEBOUNCE,
  [types.NOTIFICATION_HIDE]: PersistenceType.DEBOUNCE,
  [types.NOTIFICATIONS_DISMISS]: PersistenceType.DEBOUNCE,
  [types.NOTIFICATIONS_DISMISS_ALL]: PersistenceType.DEBOUNCE,
  [types.NOTIFICATIONS_SNOOZE]: PersistenceType.DEBOUNCE,
  [types.OPPORTUNITY_UPDATE_FILTERS]: PersistenceType.DEBOUNCE,
  [types.PIVOT_TABLE_SET_MODE]: PersistenceType.DEBOUNCE,
  [types.PIVOT_TABLE_SET_VISIBLE_COLUMNS]: PersistenceType.DEBOUNCE,
  [types.PIVOT_TABLE_SET_COLUMN_SIZES]: PersistenceType.DEBOUNCE,
  [types.PIVOT_TABLE_SET_GROUPS]: PersistenceType.DEBOUNCE,
  [types.PIVOT_TABLE_SORT]: PersistenceType.DEBOUNCE,
  [types.PIVOT_TABLE_SEARCH]: PersistenceType.DEBOUNCE,
  [types.PIVOT_TABLE_PAGE]: PersistenceType.DEBOUNCE,
  [types.PIVOT_TABLE_PAGE_SIZE_UPDATE]: PersistenceType.IMMEDIATE,
  [types.PIVOT_TABLE_TOGGLE_COLLAPSED_ITEMS]: PersistenceType.DEBOUNCE,
  [types.PRICING_CALCULATOR_RESOURCE_INCLUDE_DORMANT_TOGGLE]: PersistenceType.DEBOUNCE,
  [types.QUOTING_APPROVAL_SELECTOR_UPDATE_FILTERS]: PersistenceType.DEBOUNCE,
  [types.QUOTING_TOGGLE_OPEN_DRAFT_QUOTES]: PersistenceType.DEBOUNCE,
  [types.QUOTING_TOGGLE_OPEN_QUOTED_QUOTES]: PersistenceType.DEBOUNCE,
  [types.QUOTING_TOGGLE_OPEN_CONFIRMED_QUOTES]: PersistenceType.DEBOUNCE,
  [types.QUOTING_TOGGLE_OPEN_DELIVERED_QUOTES]: PersistenceType.DEBOUNCE,
  [types.QUOTING_TOGGLE_OPEN_INVOICED_QUOTES]: PersistenceType.DEBOUNCE,
  [types.QUOTING_TOGGLE_OPEN_PAID_QUOTES]: PersistenceType.DEBOUNCE,
  [types.QUOTING_TOGGLE_OPEN_REJECTED_QUOTES]: PersistenceType.DEBOUNCE,
  [types.QUOTING_TOGGLE_OPEN_CREDITED_QUOTES]: PersistenceType.DEBOUNCE,
  [types.QUOTING_TOGGLE_OPEN_RECENT_QUOTES_PANEL]: PersistenceType.DEBOUNCE,
  [types.QUOTING_TOGGLE_OPEN_UNSENT_QUOTES_PANEL]: PersistenceType.DEBOUNCE,
  [types.QUOTING_TOGGLE_OPEN_UNCONFIRMED_QUOTES_PANEL]: PersistenceType.DEBOUNCE,
  [types.QUOTING_TOGGLE_OPEN_REQUIRED_SOON_QUOTES_PANEL]: PersistenceType.DEBOUNCE,
  [types.QUOTING_TOGGLE_OPEN_NOT_ACCEPTED_QUOTES_PANEL]: PersistenceType.DEBOUNCE,
  [types.QUOTING_TOGGLE_OPEN_EXPIRING_QUOTES_PANEL]: PersistenceType.DEBOUNCE,
  [types.QUOTING_TOGGLE_OPEN_EXPIRED_QUOTES_PANEL]: PersistenceType.DEBOUNCE,
  [types.QUOTING_TOGGLE_OPEN_IN_PRODUCTION_PANEL]: PersistenceType.DEBOUNCE,
  [types.QUOTING_TOGGLE_OPEN_IN_DELIVERY_PANEL]: PersistenceType.DEBOUNCE,
  [types.QUOTING_TOGGLE_ACTIVE_DRAFT_QUOTES]: PersistenceType.DEBOUNCE,
  [types.QUOTING_TOGGLE_ACTIVE_QUOTED_QUOTES]: PersistenceType.DEBOUNCE,
  [types.QUOTING_TOGGLE_ACTIVE_CONFIRMED_QUOTES]: PersistenceType.DEBOUNCE,
  [types.QUOTING_TOGGLE_ACTIVE_DELIVERED_QUOTES]: PersistenceType.DEBOUNCE,
  [types.QUOTING_TOGGLE_ACTIVE_INVOICED_QUOTES]: PersistenceType.DEBOUNCE,
  [types.QUOTING_TOGGLE_ACTIVE_PAID_QUOTES]: PersistenceType.DEBOUNCE,
  [types.QUOTING_TOGGLE_ACTIVE_REJECTED_QUOTES]: PersistenceType.DEBOUNCE,
  [types.QUOTING_TOGGLE_ACTIVE_CREDITED_QUOTES]: PersistenceType.DEBOUNCE,
  [types.QUOTING_TOGGLE_ACTIVE_RECENT_QUOTES_PANEL]: PersistenceType.DEBOUNCE,
  [types.QUOTING_TOGGLE_ACTIVE_UNSENT_QUOTES_PANEL]: PersistenceType.DEBOUNCE,
  [types.QUOTING_TOGGLE_ACTIVE_UNCONFIRMED_QUOTES_PANEL]: PersistenceType.DEBOUNCE,
  [types.QUOTING_TOGGLE_ACTIVE_REQUIRED_SOON_QUOTES_PANEL]: PersistenceType.DEBOUNCE,
  [types.QUOTING_TOGGLE_ACTIVE_NOT_ACCEPTED_QUOTES_PANEL]: PersistenceType.DEBOUNCE,
  [types.QUOTING_TOGGLE_ACTIVE_EXPIRING_QUOTES_PANEL]: PersistenceType.DEBOUNCE,
  [types.QUOTING_TOGGLE_ACTIVE_EXPIRED_QUOTES_PANEL]: PersistenceType.DEBOUNCE,
  [types.QUOTING_TOGGLE_ACTIVE_IN_PRODUCTION_PANEL]: PersistenceType.DEBOUNCE,
  [types.QUOTING_TOGGLE_ACTIVE_IN_DELIVERY_PANEL]: PersistenceType.DEBOUNCE,
  [types.CONTACTS_TOGGLE_CONTACT_DETAILS_VISIBILITY]: PersistenceType.DEBOUNCE,
  [types.QUOTING_VIEW_QUOTES_UPDATE_FILTERS]: PersistenceType.DEBOUNCE,
  [types.QUOTING_VIEW_DASHBOARD_UPDATE_FILTERS]: PersistenceType.DEBOUNCE,
  [types.QUOTING_ACTIVITIES_UPDATE_FILTERS]: PersistenceType.DEBOUNCE,
  [types.QUOTING_ITEMS_UPDATE_FILTERS]: PersistenceType.DEBOUNCE,
  [types.QUOTING_INVOICES_UPDATE_FILTERS]: PersistenceType.DEBOUNCE,
  [types.QUOTING_AMENDMENTS_UPDATE_FILTERS]: PersistenceType.DEBOUNCE,
  [types.QUOTING_UPDATE_TIME_RANGE]: PersistenceType.DEBOUNCE,
  [types.QUOTING_UPDATE_SELECTED_PERSON]: PersistenceType.DEBOUNCE,
  [types.QUOTING_SELECT_QUOTE]: PersistenceType.DEBOUNCE,
  [types.QUOTING_QUOTE_SELECTOR_UPDATE_FILTERS]: PersistenceType.DEBOUNCE,
  [types.QUOTING_QUOTE_SELECTOR_TOGGLE_ITEMS]: PersistenceType.DEBOUNCE,
  [types.QUOTING_QUOTE_SELECTOR_LOAD_ITEMS]: PersistenceType.DEBOUNCE,
  [types.QUOTING_SET_SELECTED_CONTACT]: PersistenceType.DEBOUNCE,
  [types.QUOTING_SET_EMAIL_FROM_NAME]: PersistenceType.DEBOUNCE,
  [types.QUOTING_SET_EMAIL_REPLY_TO]: PersistenceType.DEBOUNCE,
  [types.QUOTING_PURCHASING_UPDATE_FILTERS]: PersistenceType.DEBOUNCE,
  [types.INVOICING_SET_EMAIL_FROM_NAME]: PersistenceType.DEBOUNCE,
  [types.INVOICING_SET_EMAIL_REPLY_TO]: PersistenceType.DEBOUNCE,
  [types.PURCHASING_SET_EMAIL_FROM_NAME]: PersistenceType.DEBOUNCE,
  [types.PURCHASING_SET_EMAIL_REPLY_TO]: PersistenceType.DEBOUNCE,
  [types.DELIVERIES_DELIVERY_NOTE_SET_EMAIL_FROM_NAME]: PersistenceType.DEBOUNCE,
  [types.DELIVERIES_DELIVERY_NOTE_SET_EMAIL_REPLY_TO]: PersistenceType.DEBOUNCE,
  [types.DELIVERIES_UPDATE_CALENDAR_FIELD_ORDER]: PersistenceType.IMMEDIATE,
  [types.DELIVERIES_UPDATE_CALENDAR_SELECTED_FIELDS]: PersistenceType.IMMEDIATE,
  [types.DELIVERIES_UPDATE_DELIVERY_FILTERS]: PersistenceType.IMMEDIATE,
  [types.DELIVERIES_QUOTE_SELECTOR_UPDATE_FILTERS]: PersistenceType.IMMEDIATE,
  [types.INVOICING_VIEW_INVOICES_UPDATE_FILTERS]: PersistenceType.DEBOUNCE,
  [types.INVOICING_PURCHASE_INVOICES_UPDATE_FILTERS]: PersistenceType.DEBOUNCE,
  [types.INVOICING_NOT_INVOICED_UPDATE_FILTERS]: PersistenceType.DEBOUNCE,
  [types.UPDATE_ADD_BULK_INVOICES_DIALOG]: PersistenceType.IMMEDIATE,
  [types.INVOICING_RECEIVED_NOT_INVOICED_UPDATE_FILTERS]: PersistenceType.DEBOUNCE,
  [types.SETTINGS_TIME_FORMAT]: PersistenceType.DEBOUNCE,
  [types.SETTINGS_DATE_FORMAT]: PersistenceType.DEBOUNCE,
  [types.SETTINGS_LOCALE]: PersistenceType.DEBOUNCE,
  [types.SETTINGS_CURRENCY_FORMAT]: PersistenceType.DEBOUNCE,
  [types.SETTINGS_CURRENCY_PRECISION]: PersistenceType.DEBOUNCE,
  [types.SETTINGS_PLAY_NOTIFICATION_SOUND_TOGGLE]: PersistenceType.DEBOUNCE,
  [types.SETTINGS_SEND_AUTOMATIC_REMINDERS_TOGGLE]: PersistenceType.DEBOUNCE,
  [types.UI_MINIMISE_HEADER]: PersistenceType.DEBOUNCE,
  [types.UI_MAXIMISE_HEADER]: PersistenceType.DEBOUNCE,
  [priceLists.types.SELECT_ALL_PRICE_LISTS]: PersistenceType.DEBOUNCE,
  [priceLists.types.SELECT_PRICE_LIST]: PersistenceType.DEBOUNCE,
  [priceLists.types.SELECT_CATEGORY]: PersistenceType.DEBOUNCE,
  [priceLists.types.SEARCH_CATEGORIES]: PersistenceType.DEBOUNCE,
  [priceLists.types.UPDATE_PART_FILTERS]: PersistenceType.DEBOUNCE,
  [types.TRACK_ROUTE]: PersistenceType.DEBOUNCE,
  [types.UN_TRACK_ROUTES]: PersistenceType.IMMEDIATE,
  [types.PRODUCTION_UPDATE_JOB_BOARD_FILTERS]: PersistenceType.DEBOUNCE,
  [types.PRODUCTION_EXPAND_WORK_CENTRE]: PersistenceType.DEBOUNCE,
  [types.PRODUCTION_UPDATE_JOB_BOARD_LIST_VIEW_FILTERS]: PersistenceType.DEBOUNCE,
  [types.PRODUCTION_COLLAPSE_WORK_CENTRE]: PersistenceType.DEBOUNCE,
  [types.PRODUCTION_TOGGLE_JOB_CARD_JOB_ADDRESS_VISIBILITY]: PersistenceType.DEBOUNCE,
  [types.PRODUCTION_MAXIMISE_JOB_CARD_DIALOG]: PersistenceType.DEBOUNCE,
  [types.PRODUCTION_RESTORE_JOB_CARD_DIALOG]: PersistenceType.DEBOUNCE,
  [types.PURCHASING_PURCHASE_ORDER_UPDATE_FILTERS]: PersistenceType.DEBOUNCE,
  [types.PURCHASING_PURCHASE_ORDER_FINDER_UPDATE_FILTERS]: PersistenceType.DEBOUNCE,
  [types.PURCHASING_ADD_ITEMS_TO_PURCHASE_ORDER_DIALOG_UPDATE_FILTERS]: PersistenceType.DEBOUNCE,
  [types.PURCHASING_SET_SELECTED_CONTACT]: PersistenceType.DEBOUNCE,
  [types.SALES_UPDATE_LEADS_FILTERS]: PersistenceType.DEBOUNCE,
  [types.SALES_UPDATE_SELLING_FILTERS]: PersistenceType.DEBOUNCE,
  [types.SALES_UPDATE_WON_FILTERS]: PersistenceType.DEBOUNCE,
  [types.SALES_UPDATE_SUCCESS_STATS_FILTERS]: PersistenceType.DEBOUNCE,
  [types.SALES_TOGGLE_SUCCESS_STATS_SELLING]: PersistenceType.DEBOUNCE,
  [types.SALES_TOGGLE_SUCCESS_STATS_LEADS]: PersistenceType.DEBOUNCE,
  [types.SALES_TOGGLE_SUCCESS_STATS_WON]: PersistenceType.DEBOUNCE,
  [types.SALES_UPDATE_USER_OR_TEAM]: PersistenceType.DEBOUNCE,
  [types.SALES_UPDATE_JOB_TYPES]: PersistenceType.DEBOUNCE,
  [types.SALES_TOGGLE_DORMANTS]: PersistenceType.DEBOUNCE,
  [types.SALES_UPDATE_SALES_ANALYSIS_QUOTING_FILTERS]: PersistenceType.DEBOUNCE,
  [types.SALES_UPDATE_SALES_ANALYSIS_INVOICING_FILTERS]: PersistenceType.DEBOUNCE,
  [types.SALES_UPDATE_SALES_ANALYSIS_DATA_SOURCE_TOGGLE]: PersistenceType.DEBOUNCE,
  [types.SETTINGS_TEAMS_TOGGLE_DORMANTS]: PersistenceType.DEBOUNCE,
  [types.PRINT_TEMPLATES_UPDATE_ORDER]: PersistenceType.DEBOUNCE,
  [types.PRINT_TEMPLATES_UPDATE_PURCHASE_ORDER]: PersistenceType.DEBOUNCE,
  [types.PRINT_TEMPLATES_UPDATE_DELIVERY_NOTE]: PersistenceType.DEBOUNCE,
  [types.PRINT_TEMPLATES_UPDATE_INVOICE]: PersistenceType.DEBOUNCE,
  [types.PRINT_TEMPLATES_QUOTE_SELECT_PRINT_TEMPLATE_GROUP_ID]: PersistenceType.DEBOUNCE,
  [types.PRINT_TEMPLATES_PURCHASE_SELECT_PRINT_TEMPLATE_GROUP_ID]: PersistenceType.DEBOUNCE,
  [types.PRINT_TEMPLATES_DELIVERIES_SELECT_PRINT_TEMPLATE_GROUP_ID]: PersistenceType.DEBOUNCE,
  [types.PRINT_TEMPLATES_INVOICE_SELECT_PRINT_TEMPLATE_GROUP_ID]: PersistenceType.DEBOUNCE,
  [priceLists.types.PRICE_LIST_TOGGLE_CATEGORY_DETAILS]: PersistenceType.DEBOUNCE,
  [priceLists.types.PRICE_LIST_TOGGLE_SUPPLIERS]: PersistenceType.DEBOUNCE,
  [types.CONTACTS_SEARCH]: PersistenceType.DEBOUNCE,
  [types.LANGUAGE_SET_TARGET]: PersistenceType.DEBOUNCE,
}

// Create a list of actions that should trigger a save of the state
export default ({type}) => {
  return Whitelist[type] || false
}
